export default __webpack_public_path__ + "static/media/P-026.43cfd0f2.png";